import axios from '@/util/axios';
import ApplicationInfo from '@/store/models/ApplicationInfo';

const state = {
	applications: <ApplicationInfo[] | null> null,
};

const getters = {
	applications: (state: any) => state.applications,
};

const mutations = {
	updateApplications: (state: any, applications: ApplicationInfo[]) => state.applications = applications,
};

const actions = {
	async getApplications(context: any, options: any) {
		try {
			const response = await axios.get('Application');
			context.commit('updateApplications', response.data);
		}
		catch (error) {
			console.error(error);
			context.commit('updateApplications', null);
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
